import React, { useEffect, useState } from "react";
import { AlertCircle } from "react-feather";
import { Button, Table, TableCell, TableRow, Typography } from "@mui/material";
import { cnpjMask } from "../../../Services/cnpjMask";
import { cpfMask } from "../../../Services/cpfMask";
import { ModalAdquirinte } from "./ModalAdquirinte";
import { Container } from "./styles";
import theme from "../../../Styles/theme";
import { Alert } from "../../Error/Alert";
import {
  AddCircle as PlusIcon,
  Edit as EditIcon,
  Delete as TrashIcon,
} from "@mui/icons-material";
import { useAdquirinte } from "../../../Storage/Adquirente";
import { ExcluirImovelModal } from "../ExcluirImovelModal";
import { ExcluirModal } from "./ExcluirModal";
export interface IAdquirinte {
  ID: string;
  NOME: string;
  RUA: string;
  NUMERO: number;
  BAIRRO: string;
  COMPLEMENTO: string;
  IMOVEL_ID: number;
  EMAIL: string;
  FONE: string;
  WHATS: string;
  CPF: string;
  CNPJ: string;
  MUNICIPIO: string;
  UF: string;
  COD_UNICO: number;
  IMOVEL_RURAL_ID:number;
}

interface Props {
  adquirinte: IAdquirinte;
  handleSetadquirinte(n_adquirinte: IAdquirinte): void;
  editavel: boolean;
}

export function Adquirinte({ handleSetadquirinte, editavel }: Props) {
  const [adquirenteFocus, setAdquirenteFocus] = useState({} as IAdquirinte);
  const [openModal, setOpenModal] = useState(false);
  const [openModalExcluir, setOpenModalExcluir] = useState(false);

  const [error, setError] = useState({ message: "", title: "" });
  const { adquirintes, getAdquirintes } = useAdquirinte();

  return (
    <>
      <Container
        interactive={editavel}
        style={{
          border: "1px solid rgba(224, 224, 224, 1)",
          padding: "0px",
          margin: "3px",
        }}
      >
        <div>
          {adquirintes.map((adquirinte) => (
            <div
              style={{
                marginBottom: "4px",
              }}
            >
              <div>
                <Table
                  size="small"
                  style={{
                    background: theme.colors.light,
                    borderRadius: "0.25rem",
                    border: "1px solid rgba(224, 224, 224, 1)",
                  }}
                >
                  <TableRow>
                    <TableCell
                      style={{
                        padding: "0px",
                      }}
                      align={"center"}
                    >
                      Nome
                    </TableCell>
                    <TableCell
                      style={{
                        padding: "0px",
                      }}
                      align={"center"}
                    >
                      {adquirinte.CPF ? "CPF" : "CNPJ"}
                    </TableCell>
                    <TableCell
                      style={{
                        padding: "0px",
                      }}
                      align={"center"}
                    >
                      Único
                    </TableCell>
                    <TableCell
                      style={{
                        padding: "0px",
                      }}
                      align={"center"}
                    >
                      Município
                    </TableCell>
                    <TableCell
                      style={{
                        padding: "0px",
                      }}
                      align="center"
                    >
                      UF
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      style={{
                        border: "1px solid rgba(224, 224, 224, 1)",
                        padding: "0px",
                        width: "40%",
                      }}
                      align={"center"}
                    >
                      {adquirinte.NOME ? adquirinte.NOME.toUpperCase() : "?"}
                    </TableCell>
                    <TableCell
                      style={{
                        border: "1px solid rgba(224, 224, 224, 1)",
                        padding: "0px",
                        width: "20%",
                      }}
                      align={"center"}
                    >
                      {adquirinte.CPF || adquirinte.CNPJ
                        ? adquirinte.CNPJ
                          ? cnpjMask(adquirinte.CNPJ)
                          : cpfMask(adquirinte.CPF)
                        : "?"}
                    </TableCell>
                    <TableCell
                      style={{
                        border: "1px solid rgba(224, 224, 224, 1)",
                        padding: "0px",
                        width: "8%",
                      }}
                      align={"center"}
                    >
                      {adquirinte.COD_UNICO ? adquirinte.COD_UNICO : "?"}
                    </TableCell>
                    <TableCell
                      align={"center"}
                      style={{
                        border: "1px solid rgba(224, 224, 224, 1)",
                        padding: "0px",
                        width: "30%",
                      }}
                    >
                      {adquirinte.MUNICIPIO
                        ? adquirinte.MUNICIPIO.toUpperCase()
                        : "?"}
                    </TableCell>
                    <TableCell
                      align={"center"}
                      style={{
                        border: "1px solid rgba(224, 224, 224, 1)",
                        padding: "0px",
                        width: "2%",
                      }}
                    >
                      {adquirinte.UF ? adquirinte.UF.toUpperCase() : "?"}
                    </TableCell>
                  </TableRow>
                </Table>

                <Table
                  size="small"
                  style={{
                    background: theme.colors.light,
                    border: "1px solid rgba(224, 224, 224, 1)",
                  }}
                >
                  <TableRow>
                    <TableCell align={"center"}>Bairro</TableCell>
                    <TableCell align={"center"}>Rua</TableCell>
                    <TableCell align={"center"}>Número</TableCell>
                    <TableCell align={"center"}>Complemento</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      style={{
                        border: "1px solid rgba(224, 224, 224, 1)",
                        padding: "0px",
                        width: "20%",
                      }}
                      align={"center"}
                    >
                      {adquirinte.BAIRRO
                        ? adquirinte.BAIRRO.toUpperCase()
                        : "?"}
                    </TableCell>
                    <TableCell
                      style={{
                        border: "1px solid rgba(224, 224, 224, 1)",
                        padding: "0px",
                        width: "30%",
                      }}
                      align={"center"}
                    >
                      {adquirinte.RUA ? adquirinte.RUA.toUpperCase() : "?"}
                    </TableCell>
                    <TableCell
                      style={{
                        border: "1px solid rgba(224, 224, 224, 1)",
                        padding: "0px",
                        width: "20%",
                      }}
                      align={"center"}
                    >
                      {adquirinte.NUMERO ? adquirinte.NUMERO : "?"}
                    </TableCell>
                    <TableCell
                      style={{
                        border: "1px solid rgba(224, 224, 224, 1)",
                        padding: "0px",
                        width: "30%",
                      }}
                      align={"center"}
                    >
                      {adquirinte.COMPLEMENTO
                        ? adquirinte.COMPLEMENTO.toUpperCase()
                        : "?"}
                    </TableCell>
                  </TableRow>
                </Table>
              </div>
              {editavel && (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-around",
                    marginBottom: "2px",
                  }}
                >
                  <Button
                    variant="contained"
                    style={{ background: theme.colors.attention, fontSize: 10 }}
                    startIcon={<TrashIcon />}
                    onClick={() => {
                      setAdquirenteFocus(adquirinte);
                      setOpenModalExcluir(true);
                    }}
                  >
                    Excluir ADQUIRENTE
                  </Button>

                  <Button
                    variant="contained"
                    style={{ fontSize: 10 }}
                    startIcon={<EditIcon />}
                    onClick={() => {
                      setAdquirenteFocus(adquirinte);
                      setOpenModal(true);
                    }}
                  >
                    Editar ADQUIRENTE
                  </Button>
                </div>
              )}
            </div>
          ))}
        </div>
        {editavel && (
          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={<PlusIcon />}
              onClick={() => {
                setAdquirenteFocus({} as IAdquirinte);
                setOpenModal(true);
              }}
              style={{ marginTop: "4px", minWidth: "300px" }}
            >
              ADICIONAR ADQUIRENTE
            </Button>
          </div>
        )}
      </Container>
      {editavel ? (
        <>
          <ModalAdquirinte
            handleSetadquirinte={handleSetadquirinte}
            open={openModal}
            onClose={() => setOpenModal(false)}
            adquirinte={adquirenteFocus}
          />
          <ExcluirModal
            open={openModalExcluir}
            onClose={() => setOpenModalExcluir(false)}
            adquirente={adquirenteFocus}
          />
        </>
      ) : (
        ""
      )}

      <Alert
        message={error.message}
        title={error.title}
        open={error.message.length > 0}
        onClose={() => setError({ message: "", title: "" })}
      />
    </>
  );
}
